import { DateTimeFormats } from 'vue-i18n'

export const messages = {
  en: {
    changeLocale: '中文',
    switch: 'Switch',
    name: 'School Platform',
    router: {
      home: 'Home',
      school: 'School',
      moment: 'Moments',
      momentDetail: 'Moment Detail',
      sendMoment: 'Add Moments',
      batchSendMoment: 'Add Moments in Bulk',
      reviewMoment: 'Review Moments',
      assessment: 'Assessment',
      assessmentSheet: 'Assessment Sheet',
      studentAssessment: 'Student Assessment',
      assessmentReport: 'Assessment Report',
      portfolio: 'Portfolio',
      editReport: 'Edit Report',
      editPortfolio: 'Edit Portfolio',
      growthProfileViewer: 'Preview Profile',
      application: 'Applications',
      attendanceMgmt: 'Attendance',
      attendanceOverview: 'Overview',
      classAttendance: 'Class Attendance',
      studentAttendance: 'Student Attendance',
      attendanceStat: 'Statistics',
      dailyCare: 'Daily Care',
      studentDailyCare: 'Student Daily Care',
      sketch: 'Sketch',
      addSketch: 'Add Sketch',
      editSketch: 'Edit Sketch',
      recipe: 'Menu',
      addRecipe: 'Add Menu',
      editRecipe: 'Edit Menu',
      recipeDetail: 'Menu Detail',
      diary: 'Diary',
      addDiary: 'Add Diary',
      editDiary: 'Edit Diary',
      studentDiary: 'Student Diary',
      album: 'Album',
      calendarMgmt: 'Calendar',
      takeLeave: 'Take Leave',
      takeLeavePending: 'Pending',
      takeLeaveAudited: 'Audited',
      mibp: 'MIBP',
      pictureBook: 'MIBP',
      pictureBookMgmt: 'Book Management',
      pictureBookDetail: 'Book Detail',
      learningJournal: 'Learning Journal',
      addLearningJournal: 'Add Learning Journal',
      editLearningJournal: 'Edit Learning Journal',
      previewLearningJournal: 'Preview Learning Journal',
      phdCourse: 'PHD',
      message: 'Message',
      inbox: 'Received',
      outbox: 'Sent',
      sendMessage: 'Send Message',
      sentDetail: 'Detail',
      replyMessage: 'Reply Message',
      receivedDetail: 'Detail',
      notification: 'Notice',
      sentNotification: 'Sent',
      createNotification: 'Create Notification',
      sentNormalNotification: 'Notification Detail',
      sentSchoolNotification: 'Notification Detail',
      receivedNotification: 'Received',
      createReply: 'Create Notification',
      receivedNormalNotification: 'Notification Detail',
      receivedSchoolNotification: 'Notification Detail',
      manage: 'Management',
      schoolMgmt: 'School Management',
      viewSchool: 'View Schools',
      classMgmt: 'Class Management',
      class: 'Classes',
      createClass: 'Create Class',
      viewClass: 'View Class',
      viewCurrent: 'View Current Student',
      viewHistory: 'View History Student',
      editClass: 'Edit Class',
      graduatedClass: 'Graduated Classes',
      viewGraduatedClass: 'View Classes',
      teachingClass: 'Teaching Classes',
      viewTeachingClass: 'View Teaching Classes',
      observingClass: 'Observing Classes',
      viewObservingClass: 'View Observing Classes',
      staffMgmt: 'Staff Management',
      viewStaff: 'View Staff',
      studentMgmt: 'Student Management',
      teacherStudent: 'My Students',
      current: 'Current Students',
      history: 'History Students',
      student: 'Students',
      viewStudent: 'View Student',
      createStudent: 'Create Student',
      editStudent: 'Edit Student',
      graduate: 'Graduates',
      viewGraduate: 'View Graduates',
      quit: 'Dropouts',
      viewQuit: 'View Dropouts',
      setting: 'Setup',
      semesterSetting: 'Semester Settings',
      sectionSetting: 'Grade Settings',
      assessmentSetting: 'Assessment Settings',
      assessmentFrameSetting: 'Assessment Framework',
      assessmentFrameDetail: 'Assessment Framework Detail',
      assessmentSheetSetting: 'Assessment Sheet',
      editAssessmentSheet: 'Edit Assessment Sheet',
      assessmentSheetDetail: 'Assessment Sheet Detail',
      assessmentParam: 'Assessment Param',
      labelSetting: 'Label Setting',
      typeSetting: 'Type Setting',
      personal: 'Personal',
      systemMessage: 'System Message',
      editRecord: 'Edit Record',
      editDetail: 'Edit Record Detail',
      testLink: 'Testing connection',
    },
    placeholder: {
      select: 'Please select',
      searchClass: 'Please enter class name',
      input: 'Please input',
    },
    gender: {
      female: 'Female',
      male: 'Male',
    },
    login: {
      accountLogin: 'Account Login',
      emailTitle: 'Contact email',
      enterAccount: 'Please enter account!',
      enterAccountPlaceholder: 'Please enter account',
      enterMobile: 'Please enter mobile phone number!',
      enterMobilePlaceholder: 'Enter mobile phone number',
      enterPassword: 'Please enter password!',
      enterPasswordPlaceholder: 'Enter password',
      enterVerifyCode: 'Please enter verify code!',
      enterVerifyCodePlaceholder: 'Enter verify code',
      login: 'Login',
      loginAuto: 'Automatic login within 7 days',
      mobileLogin: 'Mobile Login',
      resendVerifyCode: 'Reacquire after {timer}s',
      sendVerifyCode: 'Get verify code',
      sendVerifyCodeFail: 'Verify code sending failed',
      sendVerifyCodeSuccess: 'Verify code sent successfully',
      systemName: 'Skill Assessment and Teaching Management System',
      forgetPassword: 'Forget Password?',
      resetSuccessTip:
        'A password reset verification has been sent to your email address {email}. Please login with the modified password.',
      retrievePassword: 'Retrieve Password',
      next: 'Next',
      backToLogin: 'Back to login',
      setNewPassword: 'Set new password',
      enterNewPassword: 'Please enter new password',
      enterNewPasswordAgain: 'Please enter again',
      passwordNotEqual: 'The two passwords you typed do not match',
      resetPasswordSuccess: 'Modify Password Successfully',
      backAfterSeconds:
        'Back to login after {second} second | Back to login after {second} seconds',
      goToLogin: 'Go to login ({second})',
    },
    relation: {
      father: 'Father',
      mother: 'Mother',
      patGrandPa: 'Paternal Grandfather',
      patGrandMa: 'Paternal Grandmother',
      matGrandPa: 'Maternal Grandfather',
      matGrandMa: 'Maternal Grandmother',
    },
    main: {
      quit: 'Quit',
      feedback: 'Feedback',
      backToPortal: 'Back to portal',
    },
    feedback: {
      submit: 'Submit',
      title: 'Feedback',
      subtitle: 'You can write down any questions below',
      content: 'Feedback Content',
      attachment: 'Attachment',
      contact: 'Contact',
      enterContent: 'Please enter feedback content',
      enterContact: 'Please enter email for contact',
    },
    common: {
      add: 'Add',
      all: 'All',
      attention: 'Attention',
      back: 'Back',
      blankOptions: 'Please check all required fields',
      cancel: 'Cancel',
      collapse: 'Collapse',
      complete: 'Complete',
      confirm: 'Confirm',
      close: 'Close',
      delete: 'Delete',
      deleteAll: 'Delete All',
      deleteSuccess: 'Deletion successfully',
      download: 'Download',
      downloadErrorData: 'Download Error Data',
      downloadTemplate: 'Download Template',
      edit: 'Edit',
      editSuccess: 'Save successfully',
      email: 'E-mail',
      emptyName: 'You must fill either Chinese or English name',
      enName: 'Name',
      enNameInvalid: 'Your name should be within 50 characters in length',
      enter: 'Enter',
      enterName: 'Enter name',
      enterEnName: 'Enter English name',
      enterEmail: 'Enter E-mail address',
      enterContent: 'Enter content',
      enterFirstName: 'Enter first name',
      enterLastName: 'Enter last name',
      expand: 'Expand',
      firstName: 'First Name',
      freeze: 'Freeze',
      fronzenSuccess: 'Freeze successfully',
      gender: 'Gender',
      importedStudentNum: 'students | student | students',
      importedTeacherNum: 'teachers | teacher | teachers',
      importErrorTip:
        'The following data is incorrect, you can download the wrong data, modify it and then import it.',
      importing: 'Importing...',
      importResult: 'Import Result',
      inputChineseName: 'Enter Chinese name (1-50)',
      inputName: 'Enter your name (1-50)',
      lastName: 'Last Name',
      loadingFile: 'Loading file...',
      mobile: 'Phone number',
      mobileInvalid: 'Please enter a correct mobile phone number',
      name: 'Chinese Name',
      names: 'Name',
      nameInvalid: 'Your Chinese name should be within 50 Chinese characters in length',
      nameTip: 'Either Chinese name or English name is required',
      operateSuccess: 'Operate Successfully',
      operations: 'Operations',
      publish: 'Publish',
      publishSuccess: 'Publish successfully',
      replySuccess: 'Reply successfully',
      reset: 'Reset',
      resetPassword: 'Reset Password',
      resetSuccess: 'Reset successfully',
      rowNum: 'Row No.{num}',
      save: 'Save',
      saveAndSend: 'Save and Send',
      section: 'Grade',
      select: 'Select',
      sendFailed: 'Send failed',
      sendSuccess: 'Send successfully',
      send: 'Send',
      seq: 'Sequence',
      setupSuccess: 'Set successfully',
      shareSuccess: 'Share successfully',
      studentNum: '0 students | 1 student | {num} students',
      submit: 'Submit',
      successfullyImported: 'Successfully imported',
      unfreeze: 'Unfreeze',
      uploadFile: 'Upload File',
      uploadSuccess: 'Upload Successfully',
      pleaseSelect: 'Please Select',
      noActiveGradeTable: 'No Active Assessment Sheet',
      submitSuccess: 'Submit successfully, please pay attention to reply email.',
      yes: 'Yes',
      no: 'No',
    },
    home: {
      allSchools: 'All Schools',
      schoolProfile: 'School Profile',
      teachersNum: 'Teachers',
      classesNum: 'Classes',
      studentsNum: 'Students',
      parentsNum: 'Parents',
      sharedMoments: 'Moments Shared',
      momentsWithSkills: 'Moments with Skills',
      likesNum: 'Likes',
      classProfile: 'Class Profile',
      class: 'Class',
      students: 'Students',
      teachers: 'Teachers',
      parents: 'Parents',
      moments: 'Moments',
      assessment: 'Assessment Sheet',
      observedSkills: 'Observed Skills',
      assessedSkills: 'Assessed Skills',
    },
    schoolMgmt: {
      namePlaceholder: 'Please enter school name',
      shortNamePlaceholder: 'Please enter school short name',
      addressPlaceholder: 'Please enter address',
      contactPlaceholder: 'Please enter phone number',
      num: 'School Number',
      shortName: 'Abbreviation',
      name: 'Name',
      address: 'Address',
      contact: 'Contact',
      newShool: 'New',
      nameLimit: 'School name should be within 100 characters in length',
      shortNameLimit: 'Abbreviation should be within 10 characters in length',
      addressLimit: 'Address should be with in 20 characters in length',
      contactLImit: 'Please enter the contact phone number',
      editSchool: 'Edit',
      fronzenConfirm: 'Confirm frozing the selected School?',
      deleteConfirm: "After deletion, the selected school can't be restore. Confirm?",
      createSeuccess: 'School Creation successfully',
    },
    staffMgmt: {
      role: 'Role',
      rolePlaceholder: 'Please select role',
      staffNumber: 'A total of {total} staffs',
      roleType: {
        '1401': 'Group Administrator',
        '1402': 'Head School Administrator',
        '1403': 'Branch School Administrator',
        '1404': 'Administrator',
        '1405': 'Teacher',
      },
      editStaff: 'Edit staff',
      addStaff: 'Add staff',
      inputAccount: 'Enter account',
      loginAccount: 'Login account',
      email: 'E-mail',
      inputCorrectEmail: 'Please enter correct E-mail',
      inputEmail: 'Enter E-mail',
      memberInfo: 'Account infomation',
      teachingInfo: 'Teaching-related infomation',
      managingSchools: 'Schools to manage',
      managingSchoolsPlaceholder: 'Please select schools to manage',
      managingSchoolsLimit: 'A maximum of 10 schools will be selected to manage',
      accountExistIn: 'Account exist in',
      teachingClass: 'Teaching classes',
      teachingClassPlaceholder: 'Please select teaching classes',
      observingClass: 'Observing classes',
      observingClassPlaceholder: 'Please select observing classes',
      deleteConfirm: 'Confirm deleting all records related to this staff?',
      accountInfo: 'Account Info',
      account: 'Account',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      confirmDelete: 'Are you sure that the person and all his records are completely deleted?',
      noTeacher:
        'After changing the role, there will be no professors and teachers in the class [{className}]. Please add other professors and teachers in the class before deleting this person',
      importTeacher: 'Import Teacher',
      importTip1:
        'Only those who can import the teacher role, the roles above the administrator should be added manually',
      importTip2: "Teacher's name is one of the required",
      importTip3:
        "Account number and email address are required. If there are multiple professor classes and observation classes, please separate the class with '/'.",
      importTip4: 'Please follow the format in the template example.',
      confirmResetPassword:
        'The teacher can use the default password to login after reset, are you sure to reset?',
    },
    studentMgmt: {
      admissiondate: 'Enrollment Date',
      majorParent: 'Main Contact',
      contact: 'Contact',
      placement: 'Place',
      currentSection: 'Current Grade',
      unplaced: 'Unplaced',
      basicInfo: 'Student information',
      birthday: 'Birth Date',
      class: 'Class',
      section: 'Grade',
      majorParentInfo: 'Information of main contact',
      relation: 'Relationship',
      studentNumber: 'A total of {total} students',
      edit: 'Edit',
      editStudent: 'Edit Student',
      removeClass: 'Remove',
      divideClass: 'Divide',
      addStudent: 'Add Student',
      genderPlaceholder: 'Please select gender',
      birthdayPlaceholder: 'Please select birthday',
      admissionPlaceholder: 'Please select enrollment date',
      sectionPlaceholder: 'Please select current grade',
      classPlaceholder: 'Please select class',
      relationPlaceholder: 'Please select relation',
      teachers: 'Teachers',
      parentsInfo: 'Parents Info',
      parentName: 'Name',
      parentMobile: 'Mobile',
      email: 'E-mail',
      parentRelation: 'Relation',
      operation: 'operation',
      graduationDate: 'Graduation Date',
      graduationClass: 'Graduation Class',
      graduationDatePlaceholder: 'Please select graduation date',
      graduateNumber: 'A total of {total} graduates',
      unassigned: 'Unassigned',
      studentInfo: 'Student Info',
      removeParentTip: 'Are you sure to remove this parent from the student?',
      importStudent: 'Import Student',
      exportStudent: 'Export Student',
      importTip1: 'Students must have one of their English and Chinese names.',
      importTip2:
        'Current grade, enrollment time, parent and child name, mobile phone number, email address, and student relationship are required',
      importTip3:
        'Please enter the name of the class created in the background at the class name. The gender, current grade, and student relationship should be filled in from the options given below.',
      importTip4: 'Gender: Male: 1, Female: 2',
      importTip5: 'Grade: K1, K2, K3, G1, G2, G3, G4, G5',
      importTip6:
        'Relationship with students: father, mother, grandfather, grandmother, grandfather, grandmother',
      allergyInfo: 'Allergy Info / Medical History',
      allergyInfoLimit: 'Allergy Info should be with in 200 characters in length',
    },
    class: {
      enrollmentYear: 'Enrollment year',
      section: 'Grade',
      classNumber: 'A total of {total} classes',
      add: 'Add',
      serial: 'Serial',
      classId: 'Class ID',
      className: 'Class Name',
      status: 'Status',
      statusFilter: {
        1208: 'Not open',
        1209: 'Ongoing',
        1210: 'Graduated',
      },
      classOpen: 'Open at {date}',
      teachingTeacher: 'Teaching teacher',
      basicInfo: 'Basic Info',
      teachingPlan: 'Teaching Plan',
      students: 'Students',
      operation: 'Operation',
      observingTeacher: 'Observing teacher',
      edit: 'Edit',
      delete: 'Delete',
      deleteSuccess: 'Delete successful',
      openSemester: 'Open semester',
      openSemesterPlaceholder: 'Please select open semester',
      sectionPlaceholder: 'Please select grade',
      classNamePlaceholder: 'Please enter class name',
      classNameLimit: 'Class name should be with in 20 characters in length',
      append: 'Add',
      addTeachers: 'Add Teachers',
      addStudents: 'Add Students',
      conflictWarning: 'The same teacher cannot teach and observe same class at the same time',
      teacherNumLimit: 'The number of teachers exceeds the limit. Please remove the extra teachers',
      studentNumLimit: 'The number of students exceeds the limit. Please remove the extra students',
      notSaveWarning: 'Class info not saved. Are you sure to quit?',
      addClassSuccess: 'Add class successfully',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed',
      teachingTeacherPlaceholder: 'Please select teaching teacher',
      selectedStudents: 'Selected 1 student | Selected {num} students',
      selectedTeachers: 'Selected 1 teacher | Selected {num} teachers',
      studentList: 'Student List',
      studentCount: '1/50 student | {num}/50 students',
      studentUnit: 'Have 1 student | Have {num} students',
      taughtClass: 'Taught class',
      teacherList: 'Teacher List',
      teacherUnit: 'Have 1 teacher | Have {num} teachers',
    },
    graduatedClass: {
      graduateYear: 'Graduate Year',
      classNumber: 'A total of {total} classes',
      inputName: 'Please enter name',
      graduationTime: 'Graduation Time',
      graduateNumber: 'A total of {total} graduates',
      graduatedClass: 'Graduated Class',
      contact: 'Contact',
    },
    semester: {
      1204: 'Semester1',
      1205: 'Semester2',
    },
    semesterStatus: {
      1201: 'Not start',
      1202: 'Processing',
      1203: 'Over',
    },
    schoolType: {
      1230: 'Kindergarten',
      1231: 'Primary school',
    },
    week: {
      rest: 'Vac',
      0: '',
      1: 'Mon.',
      2: 'Tue.',
      3: 'Wed.',
      4: 'Thu.',
      5: 'Fri.',
      6: 'Sat.',
      7: 'Sun.',
    },
    month: {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    },
    moment: {
      all: 'All',
      draft: 'Drafts',
      recentDrafts: 'Recent drafts',
      draftBox: 'Draft box',
      deleteDraft: 'Delete draft',
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      addMoments: 'Add Moments',
      batchAddMoments: 'Add Moments in Bulk',
      noGrade: 'No grade',
      filter: 'Filter',
      review: 'Review',
      creator: 'Creator',
      date: 'Date',
      semester: 'Semester',
      semesterPlaceholder: 'Please select semester',
      skillGrade: 'Skill Grading',
      graded: 'Graded',
      ungraded: 'Ungraded',
      share: 'Share',
      shared: 'Shared',
      unshare: 'Unshare',
      reset: 'Reset filters',
      cancel: 'Cancel',
      confirm: 'Confirm',
      me: 'Me',
      parents: 'Parents',
      admins: 'Admins',
      other: 'Other Teacher',
      observationTime: 'Observation Time',
      observationRecord: 'Observation Record',
      addType: 'Add Type',
      type: 'Type',
      recordPlaceholder: 'Please enter content',
      photo: 'Photo',
      video: 'Video',
      cancelShare: 'Stop Sharing',
      shareWithParents: 'Share with Parents',
      confirmShare: 'Are you sure to share this moment with parents?',
      confirmShareClass: 'Are you sure to share this moment with class?',
      confirmStopSharing: 'Are you sure to stop sharing this moment with parents?',
      confirmStopSharingClass: 'Are you sure to stop sharing this moment with class?',
      saveDraft: 'Draft',
      publish: 'Publish',
      selectStudents: 'Select Students',
      selectSkills: 'Select Skills',
      classPlaceholder: 'Please select class',
      gradeTablePlaceholder: 'Please select assessment sheet',
      selectAll: 'Select All',
      complete: 'Complete',
      selected: 'Selected',
      grade: 'Grade',
      students: 'Students',
      applyToAll: 'Apply to all',
      applyTip: "*Click 'Grade' to apply grades to all",
      skills: 'Skills',
      reserveEdit: 'Are you sure you want to save the draft?',
      studentFirst: 'Please select student first',
      recordFirst: 'Please enter observation record',
      saveDraftSuccess: 'Save draft successfully',
      publishSuccess: 'Publish successfully',
      skillLimit: 'You can only choose 5 skills',
      gradePlaceholder: 'Please select grade',
      selectType: 'Select Type',
      expandContent: 'Expand',
      collapseContent: 'Collapse',
      point: '1point | {point}points',
      loadMore: 'Load More',
      liked: ' liked it. |  {personNum} people liked it.',
      uploadCorrectPhoto: 'Please upload photos in correct format(.jpg, .jpeg, .png)',
      uploadCorrectVideo: 'Please upload video in correct format(.mp4, .mov)',
      viewPhoto: 'View Photo',
      saveBeforeLeave: 'Edit content will not be saved after leave. Are you sure to leave?',
      deleteDraftTip: 'Are you sure to delete the draft?',
      deleteDraftSuccess: 'Delete draft successfully',
      noRecord: 'There is nothing here',
      translation: 'Translation',
      uploading: 'Uploading...',
      typeLimit: 'Type number is no more than 5',
      fullGrade: 'Full Grade',
      skillDesc: 'Skill Description',
      deleteConfirm: 'Are you sure to delete this moment?',
      pendingReview: 'Pending review',
      reviewNotApproved: 'Not approved',
      notApproved: 'Not approved',
      approved: 'Audited',
      batchApproved: 'All Approved',
      batchNotApproved: 'All Not Approved',
      pictureLink: 'Linked ({num})',
      associateStudent: 'Link to stdnt',
      associatePicture: 'Link to Picture',
      associated: 'Linked',
      select: 'Select',
      noSelectedStudents: 'Moment has not selected students yet',
      associateAllPictures: 'Please link all pictures to students',
      levelATitle: 'Level1 Skill',
      levelBTitle: 'Level2 Skill',
      apply: 'Apply',
      templateDefaultName: 'Remark template',
      confirmDeleteTemplate: 'Are you sure to delete this remark template?',
      selectRemarkTemplate: 'Select Remark Template',
      saveRemarkAsTemplate: 'Save Remark as Template',
      template: 'Template',
      remark: 'Remark',
      remarkTemplate: 'Remark Template',
      editTemplate: 'Edit Template',
      normalDraft: 'Normal Draft',
      batchDraft: 'Batch Draft',
      enterTemplateName: 'Please enter template name',
      enterTemplateContent: 'Please enter remark content',
      normalFilter: 'Normal Filter',
      skillFilter: 'Skill Filter',
      typeFilter: 'Type Filter',
      confirmApprove: 'Are you sure to approve this moment?',
      selectPhoto: 'Select Photo',
      selectVideo: 'Select Video',
      selectFromLocal: 'Local',
      selectFromAlbum: 'Album',
      photoLimit: 'Only 20 photos per Moment',
      videoLimit: 'Only 1 video per Moment',
      comment: 'Comment',
      sendTo: 'Send to',
      enterComment: 'Please enter comment',
      shareWithClass: 'Share With Class',
      loadMoreComments: '0 comments left | 1 comment left | {num} comments left',
      reply: 'Reply',
      loadMoreReplies: '0 replies left | 1 reply left | {num} replies left',
      deleteCommentConfirm: 'Are you sure to delete this comment?',
      deletedComment: '[This comment has been deleted]',
      commentSuccess: 'Comment Successfully',
      deletedMoment: 'This Moment has been deleted.',
    },
    assessment: {
      class: 'Class',
      classPlaceholder: 'Please select class',
      semester: 'Semester',
      semesterPlaceholder: 'Please select semester',
      student: 'Student',
      studentPlaceholder: 'Please select student',
      allStudents: 'All students',
      gradePeriod: 'Assessment Period',
      gradePeriodPlaceholdeer: 'Please select grade period name',
      gradeTable: 'Assessment Sheet',
      studentFreeze: 'Freeze',
      skill: 'Skills',
      assessed: 'Assessed',
      firstTime: 'First',
      secondTime: 'Second',
      thirdTime: 'Third',
      forthTime: 'Forth',
      more: 'More',
      finalGrade: 'Final Grade',
      gradeDetail: 'Grade Details',
      search: 'Search',
      generateReport: 'Generate Report',
      deleteReportTip: 'Are you sure to delete this assessment report?',
      reportName: 'Report Name',
      createTime: 'Create Time',
      operations: 'Operations',
      studentFirst: 'Please select student first',
      save: 'Save',
      chinese: 'Chinese',
      chinesePlaceholder: 'Please enter Chinese name',
      english: 'English',
      englishPlaceholder: 'Please enter English name',
      assessmentResult: 'Assessment Result',
      comment: 'Teacher Comments',
      moments: 'Moments',
      selectMoreMoments: 'Select more moments',
      grade: 'Grade',
      observationTime: 'Observation Time',
      uploadPhoto: 'Upload photos',
      selectMoments: 'Select moments',
      saveBeforeLeave: 'Edit content will not be saved after leave. Are you sure to leave?',
      saveSuccess: 'Save successfully',
      commentLimit: 'Teacher comments longer than the limit!',
      reportNameLimit: 'Please enter at least one name!',
      status: 'Status',
      minMomentTip: 'Please choose at least one Moment!',
      schoolYear: 'School Year',
      rating: 'Rating',
      sendToParent: 'Send to Parent',
      openTime: 'Open Time',
      sendTip:
        'The progress needs to reach 85% before being sent to the parents. After sending to the parents, the assessment sheet will automatically open the next one.',
      sendToParentTip:
        'After sending to parents, the grade can no longer be edited. Are you sure to send this sheet?',
      positive: 'Positive',
      negative: 'Negative',
      noStudentWarning: 'Please add at least one student',
      noPointTypeWarning: 'Please select the point type',
      point: 'Point',
      type: 'Type',
      pointComment: 'Comment',
      editComment: 'Edit Comment',
      deleteRecordTip: 'Are you sure to delete this point record?',
      deleted: 'Deleted',
      allTypes: 'All Types',
      pointType: 'Point Type',
      pointRecord: 'Point Record',
      schoolYearPointType: 'Point Type in School Year',
      totalPoint: 'Total Points',
      schoolYearTotalPoint: 'Total Points in School Year',
      pointRank: 'Point Rank',
      vacantPosition: 'Vacant Position',
      todayNewRecord: "Today's New Record",
      publishTime: 'Publish Time',
      creator: 'Creator',
      studentPoint: "Students' Points",
      addStudents: 'Add Students',
      selectAll: 'Select All',
      selectStudent: 'Select Student',
      batchGrading: 'Batch Grading',
      view: 'View',
      noMomentTip: 'No more moments',
      unselected: 'Unselected',
      selected: 'Selected',
      modifyReason: 'Modify reason',
      reasonTip: 'You have modified the skill grade of the report, please enter the reason',
      enterReason: 'Please enter edit reason!',
      modify: 'Modify',
      backToEdit: 'Back',
      gradeStatus: 'Report Grade',
      graded: 'Graded',
      noGrade: 'No Grade',
      editRecord: 'Edit Record',
      editTime: 'Edit Time',
      sendReport: 'Send Report',
      exportAssessmentSheet: 'Export Sheet',
      export: 'Export',
      confirmSend: 'The report cannot be edited after sent. Please check and confirm',
      noGradePeriod: 'There is no grade period',
      time: 'Time',
    },
    personal: {
      personalInfo: 'Personal Information',
      accountSetting: 'Account Setting',
      avatar: 'Avatar',
      modifyAvatar: 'Modify avatar',
      zhName: 'Chinese name',
      enName: 'English name',
      zhNamePlaceholder: 'Please enter Chinese name (1-50 characters)',
      enNamePlaceholder: 'Please enter English name (1-50 characters)',
      email: 'E-mail',
      emailPlaceholder: 'Please enter E-mail',
      account: 'Account',
      password: 'Password',
      modifyPassword: 'Modify password',
      save: 'Save',
      uploadAvatar: 'Click to upload avatar',
      avatarLimit: 'Support JPG, PNG format of the picture, the size of no more than 1M',
      cropTip:
        'Zoom Mouse wheel to control image display size, drag and adjust the position of the image',
      preview: 'Preview',
      reupload: 'Reupload',
      currentPassword: 'Current password',
      currentPasswordPlaceholder: 'Please enter current password',
      newPassword: 'New password',
      newPasswordPlaceholder: 'Please enter new password',
      repeatPassword: 'Repeat password',
      repeatPasswordPlaceholder: 'Please repeat new password',
      wrongAvatar: 'Please upload avatar in correct format!',
      wrongBrowser:
        'Sorry, the current browser does not support uploading avatars, please try again with a new browser',
      modifySuccess: 'Modify successfully',
      passwordLimit: 'The password must be a combination of 8-20 characters, letters and Numbers',
      wrongPassword: 'Different passwords!',
      nameInvalid: 'Name Invalid.',
    },
    attendanceMgmt: {
      editRemark: 'Edit Remark',
      status: 'Status',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      date: 'Date',
      month: 'Month',
      semester: 'Semester',
      allPresent: 'All Present',
      statTitle: {
        total: 'Total',
        present: 'Present',
        fullAttended: 'Full Attended',
        late: 'Late',
        leaveEarly: 'Leave Early',
        personalLeave: 'Personal Leave',
        sickLeave: 'Medical',
        absent: 'Absence',
        abHoliday: 'Holiday',
        Unrecorded: 'Unrecorded',
      },
      allPresentConfirm: "Are your sure to set all students' attendance to present?",
      allClass: 'All Classes',
      rate: 'Attendance',
      byDate: 'By Date',
      byMonth: 'By Month',
      bySemester: 'By Semester',
      stat: {
        attended: 'Attended (1 person) | Attended ({count} people)',
        fullAttended: 'Full Attended (1 person) | Full Attended ({count} people)',
        present: 'Present (1 person) | Present ({count} people)',
        late: 'Late (1 person) | Late ({count} people)',
        earlyLeave: 'Early Leave (1 person) | Early Leave ({count} people)',
        sickLeave: 'Medical (1 person) | Medical ({count} people)',
        personalLeave: 'Personal Leave (1 person) | Personal Leave ({count} people)',
        absent: 'Absence (1 person) | Absence ({count} people)',
        absentHoliday: 'Holiday (1 person) | Holiday ({count} people)',
        emptyRecord: 'Unrecorded (1 person) | Unrecorded ({count} people)',
        noRecordNum: '1 person no record | {count} people no record',
      },
      statByDay: {
        attended: 'Attended (1 day) | Attended ({count} days)',
        fullAttended: 'Full Attended (1 day) | Full Attended ({count} days)',
        present: 'Present (1 day) | Present ({count} days)',
        late: 'Late (1 day) | Late ({count} days)',
        earlyLeave: 'Early Leave (1 day) | Early Leave ({count} days)',
        sickLeave: 'Medical (1 day) | Medical ({count} days)',
        personalLeave: 'Personal Leave (1 day) | Personal Leave ({count} days)',
        absent: 'Absence (1 day) | Absence ({count} days)',
        absentHoliday: 'Holiday (1 day) | Holiday ({count} days)',
        emptyRecord: 'Unrecorded (1 day) | Unrecorded ({count} days)',
        noRecordNum: '1 day no record | {count} days no record',
      },
      recordTitle: {
        particallyAttended: "'s records of late",
        earlyLeave: "'s records of early leave",
        sickLeave: "'s records of absent-medical",
        personalLeave: "'s records of personal leave",
        absent: "'s records of absent",
        absentHoliday: "'s records of absent-holiday",
      },
      attendedNum: 'Attendance days',
      attendanceStat: 'Attendance Stat',
      export: 'Export Attendance Sheet',
      noClass: 'Your have no classes yet, and you cannot operate attendance.',
      noStudent: 'Your class has no students yet, and you cannot operate attendance.',
      holidayText: 'This date is holiday, you can select other date to see the statistics',
      legend: {
        remark: 'Tip',
        present: 'Means Present',
        late: 'Means Late',
        early: 'Means Leave Early',
        sick: 'Means Medical',
        personal: 'Means Personal Leave',
        absent: 'Means Absence and Holiday',
      },
      editAttendance: 'Edit Attendance',
      attendance: 'Attendance',
      remarkLimitReached: 'Remark length must not exceed 100 characters',
      noDailyCare: 'No Daily Care~',
    },
    attendanceStatus: {
      FULL_ATTENDED: 'Full Attended',
      HOLIDAY: 'Holiday',
      ATTENDED: 'Present',
      SICKNESS: 'Medical',
      ABSENT: 'Absence',
      LATE: 'Late',
      PERSONAL: 'Personal Leave',
      LEAVE_EARLY: 'Leave early',
      ABSENT_HOLIDAY: 'Holiday',
      EMPTY_RECORD: 'Unrecorded',
    },
    message: {
      title: 'Title',
      recipient: 'Recipient',
      sender: 'Sender',
      sendTime: 'Send Time',
      sendMessage: 'Send Message',
      content: 'Content',
      readStatus: 'Read Status',
      attachments: 'Attachments',
      emailNotice: 'Email notice',
      uploadAttachments: 'Upload Attachments',
      attachmentTip1: 'A single attachment is limited to 100M,',
      attachmentTip2: 'add up to 10 attachments',
      attachmentTip3: 'add up to 5 attachments',
      enterTitle: 'Please enter title',
      titleLimit: 'The title must not exceed 100 characters',
      enterContent: 'Please enter content',
      addTeachers: 'Add Teachers',
      addParents: 'Add Parents',
      addStudents: 'Add Students',
      invalidFileSize: 'A single attachment cannot exceed 100M',
      invalidFileFormat:
        'Only accept files with suffix of doc, docx, xls, xlsx, ppt, pptx, pdf, jpg, jpeg and png',
      receivedTime: 'Received Time',
      reply: 'Reply',
      history: 'History Message',
      recipientError: 'Please select recipient',
      read: 'Read',
      unread: 'Unread',
      selectSendMail: 'Please select whether to send mail',
      reserveEdit: 'The notification will not be retained after leave, are you sure to leave?',
    },
    notification: {
      notificationTitle: 'Title',
      publishTime: 'Publish Time',
      createNotification: 'Create Notification',
      scope: 'Scope',
      type: 'Type',
      readStatus: 'Read Status',
      daily: 'Daily Notification',
      activity: 'Activity Notification',
      school: 'School Reply',
      notificationStatus: 'Notification Status',
      publisher: 'Publisher',
      schoolReply: 'School Reply',
      parentReply: 'Parent Reply',
      reply: 'Reply',
      status: {
        0: 'Unread',
        1: 'Read ',
      },
      notificationContent: 'Content',
      photos: 'Photos',
      uploadPhoto: 'Upload Photos',
      attachments: 'Attachments',
      uploadAttachment: 'Upload Attachments',
      students: 'Students',
      teachers: 'Teachers',
      settings: 'Settings',
      sendMail: 'Send the notification to the recipient by mail',
      allowReply: 'Allow parents to reply',
      scopeError: 'Please select the scope of notification',
      attachmentTip1: 'Support for uploading documents, pictures and audio',
      attachmentTip2:
        'iPad does not support uploading attachments at the moment, you can use your computer to upload files.',
      saveError: 'Please enter the title and select the scope of notification first',
      typeList: {
        1600: 'Daily Notification',
        1604: 'School Reply',
      },
      uploadCorrectAttachment:
        'Please upload attachment in correct format(.doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .jpg, .jpeg, .png, .mp3, .wav)',
      reserveEdit:
        'The edited notification will not be retained after leaving. Are you sure to leave?',
      valueMissing: 'Please complete the notification before sending it',
      replyStatus: 'Reply Status',
      replyStatusList: {
        0: 'No Reply',
        1: 'Replied',
      },
      replyContent: 'Reply Content',
      deleteTip: 'Are you sure to delete this message?',
      noTitle: 'Please enter notificaiton title',
      titleLimit: 'The title is limited to 100 words',
      noContent: 'Please enter the content',
      copy: 'Copy and Edit',
      student: 'Students',
      teacher: 'Teachers',
      readPeople: 'Read (0 people) | Read (1 person) | Read ({num} people)',
      unreadPeople: 'Unread (0 people) | Unread (1 person) | Unread ({num} people)',
      replyTo: 'Reply to @',
      recipient: 'Recipient',
      historyNotification: 'History Notification',
      replyNum: 'Remaining 1 reply | Remaining {num} replies',
      addStudents: 'Add Students',
      addTeachers: 'Add Teachers',
      recipients: 'Recipients',
      time: 'Time',
      noUnread: 'There are no unread people, the notice has been delivered to all~',
      noRead: 'No one has viewed this notification yet',
      replyTime: 'Reply Time',
      noReply: 'Have not received a parent reply yet',
      sentMail: 'Sent by mail',
      unsentMail: 'Not sent by mail',
      allowedReply: 'Parental reply has been allowed',
      disallowedReply: 'Parental response not allowed',
      uploadComplete: 'Complete',
      setting: 'Setting',
      sender: 'Sender',
    },
    setting: {
      name: 'Name',
      gradeName: 'Grade Name',
      schoolYear: 'School Year',
      semester: 'Semester',
      semesterTime: 'Semester Time',
      status: 'Status',
      assessmentFrame: 'Assessment Framework',
      enabledSchoolYear: 'Enabled School Year',
      assessmentSheet: 'Assessment Sheet',
      assessmentProgress: 'Assessment Progress',
      creator: 'Creator',
      schoolType: 'School Type',
      schoolTypeTip:
        '*The type of the school does not support modification. If you want to modify it, please contact the work email help@enseed.cn',
      semesterTip:
        '*The semester does not support modification. If you want to modify it, please contact the work email help@enseed.cn',
      assessmentFrameTip:
        '*When the assessment framework is active, it cannot be modified until the end of the school year. The revision is supported within 15 days before the start of the new school year. The revised assessment sheet will also change.',
      enseedFrameIntro:
        'The assessment framework is used by students in kindergartens and elementary schools for skills assessment. </br> Under the assessment framework, the assessment skills are divided into three levels. Within one academic year, there will be a three-level assessment sheet for each month. Teachers will assess each level of skills three times a month. The value is divided into 3 levels and will be displayed in EMERGING, PERFORMING, and MASTERING. </br> After the monthly assessment is completed, parents will receive a monthly assessment sheet. At the end of the term, parents will receive a full semester assessment report. </br> After the assessment framework is active, the administrator can add an assessment sheet for the assessment framework under the assessment sheet settings menu.',
      eyfsFrameIntro:
        'The assessment framework is used by students in kindergartens and elementary schools for skills assessment. </br>Under the assessment framework, the assessment skills are divided into 2 levels, and the same assessment sheet will be used for each academic year, and each secondary skill will be assessd for an unlimited number of times. The scores are divided into 9 levels and will be displayed in Emerging1, Emerging2, Emerging3, Development4, Development5, Development6, Secure7, Secure8, and Secure9. </br> Parents will receive 2 assessment reports at the mid-term and end of the year. </br> After the assessment framework is active, the administrator can add an assessment sheet for the assessment framework under the assessment sheet settings menu.',
      frameDetailTip:
        'Once the assessment framework is active, the administrator can add an assessment sheet for the assessment framework to the assessment sheet settings menu.',
      assessmentSheetStructure: 'Assessment Sheet Structure',
      levelA: 'Level 1',
      levelB: 'Level 2',
      levelC: 'Level 3',
      levelASkill: 'Level 1 Skill',
      levelBSkill: 'Level 2 Skill',
      levelCSkill: 'Level 3 Skill',
      lastLevelTip: 'Customizable Skills',
      leaveTip: 'The edited content will not be retained after leaving. Are you sure to leave?',
      addLevelBSkill: 'Add second level skills',
      addLevelCSkill: 'Add third level skills',
      doubleSheetName:
        'An assessment sheet with the same name already exists under the framework and grade. Please modify the name of the assessment sheet.',
      deleteLevelBTip: 'Are you sure to delete the second level skill?',
      deleteLevelCTip: 'Are you sure to delete the third level skill?',
      order: 'Order',
      introduction: 'Introduction',
      abbreviation: 'Abbreviation',
      noAbbreviation: 'Please enter abbreviation',
      abbreviationLimit: 'The number of abbreviations cannot exceed 10 characters',
      noLevelCSkill: 'Please enter the third level skill',
      noLevelBSkill: 'Please enter the second level skill',
      rubrics: 'Rubrics',
      all: 'All',
      enable: 'Active',
      disable: 'Inactive',
      disabled: 'Unactivated',
      enabled: 'Active',
      deleteAssessmentSheet: 'Are you sure to delete this assessment sheet?',
      enableEnSEEDAssessmentSheet: 'Are you sure to enable this assessment sheet?',
      enableEYFSAssessmentSheet:
        'After the enable, the assessment sheet will be replaced, are you sure to enable it?',
      disableAssessmentSheet:
        'After the disable, the class assessment will not use this assessment sheet, are you sure to disable it?',
      sentToParent: 'Sent to parent',
      unsentToParent: 'Unsent to parent',
      enterName: 'Please enter name',
      adjustOrder: 'Adjust Use Order',
      createSheet: 'Create Assessment Sheet',
      up: 'Up',
      down: 'Down',
      sendStatus: 'Send Status',
      appliedSection: 'Applied Section',
      sheetOrder: 'Assessment Sheet Order',
      createTime: 'Create Time',
      enterSheetName: 'Please enter assessment sheet name',
      orderTip1: "Only not assessed assessment sheet's order can be adjusted",
      orderTip2:
        'Teachers will assess according to the order in which the assessment sheet are used',
      saveTip: 'The assessment sheet requires at least one level 3 skill',
      typeSetting: 'Type',
      typeTip: 'Tip: This label is used to select the type when posting moment.',
      addType: 'Add Type',
      deleteTypeTip: 'Are you sure to delete this type?',
      abbrRepeat: 'Skill abbreviations are repeated, please change the abbreviation',
      sendToParent: 'Whether to send to parents',
      canSend: 'Can send',
      cannotSend: "Can't send",
      sendPercent: 'Percent allowed to send',
      textLimit: 'Text limit exceeded',
    },
    assessmentStatus: {
      1302: 'Assessing',
      1303: 'Not Assessed',
      1304: 'Assessed',
    },
    assessmentReportStatus: {
      1501: 'Unsent',
      1502: 'Sent',
    },
    calendar: {
      schoolYear: 'School Year {year}',
      holidayPlaceholder: 'Enter holiday name',
      deleteConfirm: 'Are you sure to delete this schedule?',
      workingDay: 'Working Day',
      holiday: 'Holiday',
      summerHoliday: 'Summer Holiday',
      winterHoliday: 'Winter Holiday',
      semesterStartDate: 'Start of semester',
      semesterEndDate: 'End of semester',
      setDate: 'Set Working Day / Holiday',
      addSchedule: 'Set Schedule',
      openParentView: 'View Parent View',
      closeParentView: 'Exit Parent View',
      date: 'Date',
      name: 'Name',
      time: 'Time',
      allDay: 'All Day',
      location: 'Location',
      remark: 'Remark',
      status: 'Status',
      visibleToParent: 'Visible To Parents',
      invisibleToParent: 'Invisible To Parents',
      viewSchedule: 'View Schedule',
    },
    curriculum: {
      class: 'Class',
      allClass: 'All Classes',
      semester: 'Semester',
      allSemester: 'All Semesters',
      createCurriculum: 'Create Curriculum',
      name: 'Name',
      date: 'Date',
      creator: 'Creator',
      createTime: 'Create Time',
      confirmDelete: 'Are you sure to delete this curriculum?',
      uploadCurriculum: 'Upload Curriculum',
      namePlaceholder: 'Please enter name',
      semesterPlaceholder: 'Please select semester',
      classPlaceholder: 'Please select class',
      pdfNotSupport: 'This browser does not support PDFs. Please download the PDF to view it:',
      downloadPDF: 'Download PDF',
    },
    pictureBook: {
      pictureBook: 'Picture Book',
      suitableSection: 'Suitable Grade',
      bookNum: 'Book Number',
      subscribeNum: "Subscribers' Number",
      operateRecord: 'Operate Record',
      date: 'Date',
      name: 'Name',
      section: 'Grade',
      namePlaceholder: 'Please enter student name',
      student: 'Student',
      class: 'Class',
      operator: 'Operator',
      operateTime: 'Operate Time',
      openDate: 'Open Date',
      subscribeDetail: 'Subscribe Detail',
      subscribed: 'Subscribed',
      notSubscribed: 'Not Subscribed',
      batchStopSubscribe: 'Batch stop subscribe',
      batchBeginSubscribe: 'Batch begin subscribe',
      studentNum: '0 students | 1 student | {num} students',
      expand: 'Expand',
      collapse: 'Collapse',
      stopSubscribe: 'Stop Subscribe',
      beginSubscribe: 'Begin Subscribe',
      stopSuccess: 'Stop subscribe successfully',
      beginSuccess: 'Begin subscribe successfully',
      confirmStopSubscribe: 'Are you sure to stop subscribe?',
      confirmBeginSubscribe: 'Are you sure to begin subscribe?',
      open: 'Open at {time}',
    },
    mibp: {
      firstPage: 'Already the first page',
      lastPage: 'Already the last page',
      loading: 'Loading... {progress}',
    },
    phdCourse: {
      firstPage: 'Already the first page',
      lastPage: 'Already the last page',
      loading: 'Loading... {progress}',
      cover: 'Cover',
      catalog: 'Catalog',
    },
    weekday: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
    },
    noContent: {
      attendance: 'No attendance records~',
      moment: 'No moments~',
      template: 'Comment template has not been saved yet',
      draft: 'No drafts~',
      parentReply: 'No parent replies~',
      pendingReview: 'No pending review of moments~',
      reviewNotAudited: 'No moments not approved~',
      systemMessage: 'No more messages~',
      class: 'No Classes',
      schoolYear: 'No School Years',
      semester: 'No Semesters',
      student: 'No Students',
      gradePeriod: 'No Grade Periods',
      section: 'No Grades',
      gradeTable: 'No Grade Tables',
      book: 'No Picture Books',
      file: 'No Files',
      deletedMoment: 'Moment has been deleted',
      photo: 'No Photos~',
      video: 'No Videos~',
    },
    album: {
      class: 'Class',
      uploadPhoto: 'Upload Photo',
      uploadVideo: 'Upload Video',
      bulkManage: 'Bulk Manage',
      photo: 'Photo',
      video: 'Video',
      download: 'Download',
      delete: 'Delete',
      completeManage: 'Complete',
      selectedNum: 'Selected: {num}',
      totalNum: 'Total: {num}',
      clear: 'Clear',
      selectAll: 'Select All',
      selectMonthAll: 'All this month',
      upload: 'Upload',
      complete: 'Complete',
      continueUpload: 'Upload',
      uploadPhotoSuccess: '1 photo uploaded successfully | {num} photos uploaded successfully',
      uploadPhotoFailed: '1 photo upload failed | {num} photos upload failed',
      uploadVideoSuccess: '1 video uploaded successfully | {num} videos uploaded successfully',
      uploadVideoFailed: '1 video upload failed | {num} videos upload failed',
      uploadFailed: 'Upload Failed',
      createTime: 'Create Time',
      creator: 'Creator',
      source: 'Source',
      sourceType: {
        1451: 'Album',
        1452: 'Moments',
      },
      deletePhotoConfirm: 'Are you sure to delete photos?',
      deleteVideoConfirm: 'Are you sure to delete videos?',
      selectedPhotoStat: 'Selected 0 photos | Selected 1 photo | Selected {selected} photos',
      totalPhoto: ', total: 0 photos | , total: 1 photo | , total: {total} photos',
      selectedVideoStat: 'Selected 0 videos | Selected 1 video | Selected {selected} videos',
      totalVideo: ', total: 0 videos | , total: 1 video | , total: {total} videos',
      waitingUpload: 'Waiting Upload',
      preview: 'Preview',
    },
    dailyCare: {
      class: 'Class',
      date: 'Date',
      name: 'Name',
      snack: 'Snack',
      am: 'AM',
      pm: 'PM',
      lunch: 'Lunch',
      nap: 'Nap',
      toilet: 'Toilet',
      urinate: 'Urinate',
      defecate: 'Faeces',
      remark: 'Remark',
      lifeLevel: {
        green: 'Green: Healthy',
        yellow: 'Yellow: Requires attention',
        red: 'Red: Requires immediate action',
      },
      times: '0 times | once | twice | {count} times',
      student: 'Student',
      performance: 'Performance',
      record: ' Record',
      time: 'Time',
      dailyCareTip: 'Daily performance level description',
      remarkLimitReached: 'Remark length must not exceed 400 characters',
    },
    diary: {
      name: 'Name',
      points: 'Points',
      count: 'Count',
      positive: 'Positive',
      negative: 'Negative',
      nurseVisit: 'Nurse Visit',
      diaryType: 'Diary Type',
      subtype: 'Subtype',
      time: 'Time',
      location: 'Location',
      relatedStudents: 'Related Students',
      description: 'Description',
      injuredParts: 'Injured Parts',
      attachments: 'Attachments',
      shareWithParents: 'Share With Parents',
      uploadAttachments: 'Upload Attachments',
      addStudents: 'Add Students',
      attachmentTip: 'Single attachment is limited to 100M',
      submitSuccess: 'Submit Successfully',
      selectDiaryType: 'Please select diary type',
      selectSubtype: 'Please select subtype',
      inputDescription: 'Please input description',
      class: 'Class',
      totalPoints: 'Total',
      createTime: 'Create Time',
      creator: 'Creator',
      diaryDetail: 'Diary Detail',
      deleteDiaryTip: 'Are you sure to delete this diary?',
      reserveEdit: 'The diary will not be retained after leave, are you sure to leave?',
    },
    takeLeave: {
      class: 'Class',
      student: 'Student',
      leavePeople: 'People',
      leaveType: 'Type',
      leaveDuration: 'Duration',
      leaveReason: 'Reason',
      status: 'Status',
      leaveTime: 'Time',
      illness: 'Medical',
      personal: 'Personal',
      /* eslint-disable-next-line */
      absent_holiday: 'Holiday',
      pending: 'Pending',
      approved: 'Approved',
      declined: 'Declined',
      retrieved: 'Withdrawn',
      am: 'AM',
      pm: 'PM',
      day: '0 days | {duration} day | {duration} days',
      approve: 'Approve',
      reject: 'Reject',
      approveConfirm:
        'After the leave is approved, the attendance status will be automatically synchronized. Are you sure to approval it?',
      rejectConfirm: 'Are you sure to reject this application?',
      leaveAudit: 'Leave Audit',
      leaveStatus: 'Leave Status',
    },
    operation: {
      9001: 'Stop Subscribe',
      9002: 'Begin Subscribe',
    },
    systemMessage: {
      time: 'Time',
      type: {
        1651: 'Grade Modification',
        1613: 'Moment Favor',
        1614: 'Moment Comment',
        1622: 'Audit',
      },
      typeDescription: {
        1651: 'modified this grade',
        1613: 'liked this moment',
        1614: 'commented this moment',
        1622: 'Leave Approval Notice',
      },
    },
    transfer: {
      listTitle: '{title} List',
      selectedNum: 'Selected {num} {title}s',
      deleteAll: 'Delete All',
      selectAll: 'Select All',
      enterName: 'Please enter {title} name',
      ungrouped: 'Ungrouped',
      undivided: 'Undivided',
    },
    notFound: {
      notFound: 'Sorry, the page you visited does not exist.',
      backToHome: 'Back to Home',
    },
  },
  zh: {
    changeLocale: 'English',
    switch: '切换',
    name: '学校平台',
    router: {
      home: '首页',
      school: '学校',
      moment: '成长记录',
      momentDetail: '成长记录详情',
      sendMoment: '添加成长记录',
      batchSendMoment: '批量添加成长记录',
      reviewMoment: '审核成长记录',
      assessment: '评估',
      assessmentSheet: '评估表',
      studentAssessment: '学生技能评估',
      assessmentReport: '评估报告',
      portfolio: '成长档案',
      editReport: '编辑评估报告',
      editPortfolio: '编辑成长档案',
      growthProfileViewer: '预览成长档案',
      application: '应用中心',
      attendanceMgmt: '考勤管理',
      attendanceOverview: '考勤概览',
      classAttendance: '班级考勤',
      studentAttendance: '学生考勤',
      attendanceStat: '考勤统计',
      dailyCare: '生活记录',
      studentDailyCare: '学生生活记录',
      sketch: '画板',
      addSketch: '新增画板',
      editSketch: '编辑画板',
      recipe: '食谱',
      addRecipe: '新增食谱',
      editRecipe: '编辑食谱',
      recipeDetail: '食谱详情',
      diary: '日记簿',
      addDiary: '新增日记簿',
      editDiary: '编辑日记簿',
      studentDiary: '学生日记簿',
      album: '班级相册',
      calendarMgmt: '校历管理',
      takeLeave: '请假审批',
      takeLeavePending: '待审核',
      takeLeaveAudited: '已审批',
      mibp: '多元智能双语课程',
      pictureBook: '多元智能双语课程',
      pictureBookMgmt: '绘本管理',
      pictureBookDetail: '绘本详情',
      learningJournal: '学习日志',
      addLearningJournal: '新增学习日志',
      editLearningJournal: '编辑学习日志',
      previewLearningJournal: '预览学习日志',
      phdCourse: 'PHD',
      message: '消息通知',
      inbox: '我收到的',
      outbox: '我发出的',
      sendMessage: '发消息',
      sentDetail: '消息详情',
      replyMessage: '回复消息',
      receivedDetail: '消息详情',
      notification: '消息通知',
      sentNotification: '我发出的',
      createNotification: '发通知',
      sentNormalNotification: '通知详情',
      sentSchoolNotification: '通知详情',
      receivedNotification: '我收到的',
      createReply: '发通知',
      receivedNormalNotification: '通知详情',
      receivedSchoolNotification: '通知详情',
      manage: '管理数据',
      schoolMgmt: '学校管理',
      viewSchool: '查看学校',
      classMgmt: '班级管理',
      class: '班级',
      createClass: '新增班级',
      viewClass: '查看班级',
      editClass: '编辑班级',
      graduatedClass: '历史班级',
      viewGraduatedClass: '查看班级',
      viewCurrent: '查看现教学生',
      viewHistory: '查看历史学生',
      staffMgmt: '人员管理',
      viewStaff: '查看人员',
      studentMgmt: '学生管理',
      teacherStudent: '我的学生',
      history: '历史学生',
      current: '现教学生',
      student: '在校生',
      viewStudent: '查看学生',
      createStudent: '新增学生',
      editStudent: '编辑学生',
      graduate: '毕业生',
      viewGraduate: '查看毕业生',
      quit: '退学生',
      viewQuit: '查看退学生',
      setting: '设置',
      semesterSetting: '学期设置',
      sectionSetting: '年级设置',
      assessmentSetting: '评估设置',
      assessmentFrameSetting: '评估框架',
      assessmentFrameDetail: '评估框架详情',
      assessmentSheetSetting: '评估表',
      editAssessmentSheet: '编辑评估表',
      assessmentSheetDetail: '评估表详情',
      assessmentParam: '评估参数',
      labelSetting: '字段设置',
      typeSetting: '类型设置',
      personal: '个人中心',
      systemMessage: '系统消息',
      editRecord: '修改记录',
      editDetail: '修改记录详情',
      testLink: '测试链接',
    },
    placeholder: {
      select: '请选择',
      searchClass: '请输入班级名称',
      input: '请输入',
    },
    gender: {
      male: '男',
      female: '女',
    },
    login: {
      accountLogin: '账号密码登录',
      emailTitle: '联系邮箱',
      enterAccount: '请输入账号！',
      enterAccountPlaceholder: '请输入账号',
      enterMobile: '请输入手机号！',
      enterMobilePlaceholder: '请输入手机号',
      enterPassword: '请输入密码！',
      enterPasswordPlaceholder: '请输入密码',
      enterVerifyCode: '请输入验证码！',
      enterVerifyCodePlaceholder: '请输入验证码',
      login: '登录',
      loginAuto: '7天内自动登录',
      mobileLogin: '验证码登录',
      resendVerifyCode: '{timer}秒后重新获取',
      sendVerifyCode: '获取验证码',
      sendVerifyCodeFail: '验证码发送失败',
      sendVerifyCodeSuccess: '验证码发送成功',
      systemName: '素质评估与教学管理系统',
      forgetPassword: '忘记密码?',
      resetSuccessTip: '已向您的邮箱{email}发送重置密码验证，请使用修改后的密码进行登录',
      retrievePassword: '找回密码',
      next: '下一步',
      backToLogin: '返回登录页',
      setNewPassword: '设置新密码',
      enterNewPassword: '请输入新密码',
      enterNewPasswordAgain: '请再输入一遍',
      passwordNotEqual: '两次输入的密码不一致',
      resetPasswordSuccess: '修改密码成功',
      backAfterSeconds: '{second}秒后返回登录页',
      goToLogin: '去登录({second})',
    },
    relation: {
      father: '爸爸',
      mother: '妈妈',
      patGrandPa: '爷爷',
      patGrandMa: '奶奶',
      matGrandPa: '外公',
      matGrandMa: '外婆',
    },
    main: {
      quit: '退出',
      feedback: '意见反馈',
      backToPortal: '返回主平台',
    },
    feedback: {
      submit: '提交',
      title: '意见反馈',
      subtitle: '如果您有任何问题，可以写在下方',
      content: '反馈内容',
      attachment: '附件',
      contact: '联系方式',
      enterContent: '请输入反馈内容',
      enterContact: '请输入联系邮箱，以便客服联系您',
    },
    common: {
      add: '新增',
      all: '全部',
      attention: '注意',
      back: '返回',
      blankOptions: '请检查所有必填项',
      cancel: '取消',
      close: '关闭',
      collapse: '收起',
      complete: '完成',
      confirm: '确定',
      delete: '删除',
      deleteAll: '删除全部',
      deleteSuccess: '删除成功',
      download: '下载',
      downloadErrorData: '下载错误数据',
      downloadTemplate: '下载导入模版',
      edit: '编辑',
      editSuccess: '编辑成功',
      email: '邮箱',
      emptyName: '中文名和英文名至少填写一个',
      enName: '英文名',
      enNameInvalid: '英文名长度为1-50字符',
      enter: '请输入',
      enterContent: '请输入内容',
      enterEmail: '请输入邮箱',
      enterEnName: '请输入英文名',
      enterFirstName: '请输入姓',
      enterLastName: '请输入名',
      enterName: '请输入姓名',
      expand: '展开',
      firstName: '名',
      freeze: '冻结',
      fronzenSuccess: '冻结成功',
      gender: '性别',
      importedStudentNum: '位学生',
      importedTeacherNum: '位教师',
      importing: '导入中...',
      importErrorTip: '以下数据有误，您可下载错误数据，修改后再导入',
      importResult: '导入结果',
      inputChineseName: '请输入中文名(1-50)',
      inputName: '请输入英文名(1-50)',
      lastName: '姓',
      loadingFile: '加载文件中...',
      mobile: '手机号',
      mobileInvalid: '请输入正确的手机号',
      name: '中文名',
      nameInvalid: '中文名长度为1-50字符',
      names: '姓名',
      nameTip: '中文名和英文名二选一必填',
      operateSuccess: '操作成功',
      operations: '操作',
      publish: '发布',
      publishSuccess: '发布成功',
      replySuccess: '回复成功',
      reset: '重置',
      resetPassword: '重置密码',
      resetSuccess: '重置密码成功',
      rowNum: '第{num}行',
      save: '保存',
      saveAndSend: '保存并发送',
      section: '年级',
      select: '请选择',
      send: '发送',
      sendFailed: '发送失败',
      sendSuccess: '发送成功',
      seq: '序号',
      setupSuccess: '设置成功',
      shareSuccess: '分享成功',
      studentNum: '{num} 人',
      submit: '提交',
      successfullyImported: '成功导入',
      unfreeze: '启用',
      uploadFile: '上传文件',
      uploadSuccess: '上传成功',
      pleaseSelect: '请选择',
      noActiveGradeTable: '当前没有激活的评估表',
      submitSuccess: '提交成功，请注意接收回复邮件',
      yes: '是',
      no: '否',
    },
    home: {
      allSchools: '全部学校',
      schoolProfile: '学校概况',
      teachersNum: '教师数量',
      classesNum: '班级数量',
      studentsNum: '学生数量',
      parentsNum: '家长数量',
      sharedMoments: '已分享的成长记录',
      momentsWithSkills: '与技能相关的成长记录',
      likesNum: '点赞数',
      classProfile: '班级概况',
      class: '班级',
      students: '学生数量',
      teachers: '老师',
      parents: '家长数量',
      moments: '成长记录',
      assessment: '当前评估表',
      observedSkills: '已观察技能',
      assessedSkills: '已评估技能',
    },
    schoolMgmt: {
      namePlaceholder: '请输入学校名称',
      shortNamePlaceholder: '请输入学校简称',
      addressPlaceholder: '请输入学校地址',
      contactPlaceholder: '请输入学校电话',
      num: '学校编号',
      shortName: '学校简称',
      name: '学校名称',
      address: '学校地址',
      contact: '学校电话',
      newShool: '新增学校',
      nameLimit: '学校名称限制1-100字符',
      shortNameLimit: '学校简称限制1-10字符',
      addressLimit: '学校地址限制1-20字符',
      contactLImit: '请输入学校电话',
      editSchool: '编辑学校',
      fronzenConfirm: '确认冻结学校?',
      deleteConfirm: '删除后该学校将无法启用，确认删除学校？',
      createSeuccess: '新增学校成功',
    },
    staffMgmt: {
      role: '角色',
      rolePlaceholder: '请选择角色',
      staffNumber: '共有{total}位人员',
      roleType: {
        '1401': '集团管理员',
        '1402': '总校管理员',
        '1403': '学校管理员',
        '1404': '管理员',
        '1405': '教师',
      },
      editStaff: '编辑人员',
      addStaff: '新增人员',
      inputAccount: '请输入账号',
      loginAccount: '登录账号',
      email: '邮箱',
      inputCorrectEmail: '请输入正确的邮箱',
      inputEmail: '请输入邮箱',
      memberInfo: '账户信息',
      teachingInfo: '教学信息',
      managingSchools: '管理学校',
      managingSchoolsPlaceholder: '请选择管理学校',
      managingSchoolsLimit: '最多选择10个学校进行管理',
      accountExistIn: '账号存在于',
      teachingClass: '教授班级',
      teachingClassPlaceholder: '请选择教授班级',
      observingClass: '观察班级',
      observingClassPlaceholder: '请选择观察班级',
      deleteConfirm: '确定彻底删除该人员及其所有记录？',
      accountInfo: '账号信息',
      account: '账号',
      addSuccess: '新增成功',
      editSuccess: '编辑成功',
      confirmDelete: '确定彻底删除该人员及其所有记录？',
      noTeacher:
        '修改角色后班级【{className}】将没有教授老师，请先在班级中添加其他教授老师再删除此人员',
      importTeacher: '导入教师',
      importTip1: '只能导入教师角色的人员，管理员以上的角色请手动添加',
      importTip2: '教师姓名为必填之一',
      importTip3: '账号、邮箱为必填，若有多个教授班级和观察班级，请用“/”将班级隔开',
      importTip4: '请按照模版示例里面的格式填写',
      confirmResetPassword: '重置后教师可以用默认密码登录，确定重置密码？',
    },
    studentMgmt: {
      admissiondate: '入校时间',
      majorParent: '主要联系人',
      contact: '主要联系人联系方式',
      placement: '分班',
      currentSection: '当前年级',
      unplaced: '未分配班级',
      basicInfo: '基本信息',
      birthday: '出生日期',
      class: '班级',
      section: '年级',
      majorParentInfo: '主要联系人信息',
      relation: '与学生关系',
      studentNumber: '共有{total}位学生',
      edit: '编辑',
      editStudent: '编辑学生',
      removeClass: '移出班级',
      divideClass: '分班',
      addStudent: '新增学生',
      genderPlaceholder: '请选择性别',
      birthdayPlaceholder: '请选择出生日期',
      admissionPlaceholder: '请选择入校时间',
      sectionPlaceholder: '请选择当前年级',
      classPlaceholder: '请选择班级',
      relationPlaceholder: '请选择与学生关系',
      teachers: '班级教师',
      parentsInfo: '家长信息',
      parentName: '姓名',
      parentMobile: '手机号',
      email: '邮箱',
      parentRelation: '与学生关系',
      operation: '操作',
      graduationDate: '毕业日期',
      graduationClass: '毕业班级',
      graduationDatePlaceholder: '请选择毕业日期',
      graduateNumber: '共有{total}名毕业生',
      unassigned: '未分配班级',
      studentInfo: '学生信息',
      removeParentTip: '确定要删除这位家长吗？',
      importStudent: '导入学生',
      exportStudent: '导出学生',
      importTip1: '学生中英文名必填其一',
      importTip2: '当前年级、入校时间、主要联系人姓名、手机号、邮箱、与学生关系为必填',
      importTip3:
        '班级名称处请填入后台已创建的班级名称，其中性别、当前年级、与学生关系请从下面给出的选项中填入',
      importTip4: '性别：男: 1 、女: 2',
      importTip5: '年级：K1、K2、K3、G1、G2、G3、G4、G5',
      importTip6: '与学生关系：爸爸、妈妈、爷爷、奶奶、外公、外婆',
      allergyInfo: '过敏信息/病史',
      allergyInfoLimit: '过敏信息为200字符以内',
    },
    class: {
      enrollmentYear: '入学年份',
      section: '年级',
      classNumber: '共有{total}个班级',
      add: '新增',
      serial: '序号',
      classId: '班级编号',
      className: '班级名称',
      status: '状态',
      statusFilter: {
        1208: '未开启',
        1209: '进行中',
        1210: '已毕业',
      },
      classOpen: '{date}开启',
      teachingTeacher: '教授老师',
      students: '学生',
      operation: '操作',
      edit: '编辑',
      delete: '删除',
      deleteSuccess: '删除成功',
      basicInfo: '基本信息',
      observingTeacher: '观察老师',
      teachingPlan: '教学计划',
      openSemester: '开启学期',
      openSemesterPlaceholder: '请选择开启学期',
      sectionPlaceholder: '请选择年级',
      classNamePlaceholder: '请输入班级名称',
      classNameLimit: '班级名称为1-20字符',
      append: '添加',
      addTeachers: '添加老师',
      addStudents: '添加学生',
      conflictWarning: '同一名老师不能同时为教授老师和观察老师',
      teacherNumLimit: '老师数量超出上限，请移除多余的老师',
      studentNumLimit: '学生数量超出上限，请移除多余的学生',
      notSaveWarning: '班级未保存，确定退出？',
      addClassSuccess: '新增班级成功',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      teachingTeacherPlaceholder: '请选择教授老师',
      selectedStudents: '已选{num}人',
      selectedTeachers: '已选{num}人',
      studentList: '学生列表',
      studentCount: '{num}/50人',
      studentUnit: '已选择学生{num}人',
      taughtClass: '已教授班级',
      teacherList: '教师列表',
      teacherUnit: '已选择教师{num}人',
    },
    graduatedClass: {
      graduateYear: '毕业年份',
      classNumber: '共有{total}个班级',
      inputName: '请输入姓名',
      graduationTime: '毕业时间',
      graduateNumber: '共{total}名毕业生',
      graduatedClass: '毕业班级',
      contact: '联系方式',
    },
    semester: {
      1204: '上学期',
      1205: '下学期',
    },
    semesterStatus: {
      1201: '未开始',
      1202: '进行中',
      1203: '已结束',
    },
    schoolType: {
      1230: '幼儿园',
      1231: '小学',
    },
    week: {
      rest: '休',
      0: '',
      1: '一',
      2: '二',
      3: '三',
      4: '四',
      5: '五',
      6: '六',
      7: '日',
    },
    month: {
      1: '一月',
      2: '二月',
      3: '三月',
      4: '四月',
      5: '五月',
      6: '六月',
      7: '七月',
      8: '八月',
      9: '九月',
      10: '十月',
      11: '十一月',
      12: '十二月',
    },
    moment: {
      all: '全部',
      draft: '草稿',
      recentDrafts: '最近草稿',
      draftBox: '草稿箱',
      deleteDraft: '删除草稿',
      edit: '编辑',
      copy: '复制并编辑',
      delete: '删除',
      addMoments: '添加成长记录',
      batchAddMoments: '批量添加成长记录',
      noGrade: '无评分',
      filter: '筛选',
      review: '审核',
      creator: '创建者',
      date: '日期',
      semester: '学期',
      semesterPlaceholder: '请选择学期',
      skillGrade: '技能评分',
      graded: '已评分',
      ungraded: '未评分',
      share: '分享',
      shared: '已分享',
      unshare: '未分享',
      reset: '重置筛选',
      cancel: '取消',
      confirm: '确定',
      me: '我自己',
      parents: '家长',
      admins: '管理员',
      other: '其他教师',
      observationTime: '发生时间',
      observationRecord: '活动观察记录',
      addType: '添加类型',
      type: '类型',
      recordPlaceholder: '请输入内容',
      photo: '照片',
      video: '视频',
      cancelShare: '取消分享',
      shareWithParents: '分享给家长',
      confirmShare: '确认分享给家长？',
      confirmShareClass: '确认分享到班级？',
      confirmStopSharing: '确认取消分享给家长？',
      confirmStopSharingClass: '确认取消分享到班级？',
      saveDraft: '存草稿',
      publish: '发布',
      selectStudents: '选择学生',
      selectSkills: '选择技能',
      classPlaceholder: '请选择班级',
      gradeTablePlaceholder: '请选择评估表',
      selectAll: '全选',
      complete: '完成',
      selected: '已选',
      grade: '评分',
      students: '学生',
      applyToAll: '全部应用',
      applyTip: '*点击"评分"可以全部应用分数',
      skills: '技能',
      reserveEdit: '仍有正在编辑的成长记录，是否保存为草稿？',
      studentFirst: '请先选择学生',
      recordFirst: '请先填写观察记录内容',
      saveDraftSuccess: '草稿保存成功',
      publishSuccess: '发布成功',
      skillLimit: '只能选择5个技能',
      gradePlaceholder: '请选择评分',
      selectType: '选择类型',
      expandContent: '展开全文',
      collapseContent: '收起全文',
      point: '{point}分',
      loadMore: '加载更多',
      liked: '共1人觉得很赞 | 共{personNum}人觉得很赞',
      uploadCorrectPhoto: '请上传正确格式的照片(.jpg, .jpeg, .png)',
      uploadCorrectVideo: '请上传正确格式的视频(.mp4, .mov)',
      viewPhoto: '查看照片',
      saveBeforeLeave: '退出后编辑内容不会保存，确认退出编辑？',
      deleteDraftTip: '确定要删除草稿吗？',
      deleteDraftSuccess: '删除草稿成功',
      noRecord: '没有成长记录',
      translation: '翻译',
      uploading: '上传中...',
      typeLimit: '类型最多选择5个',
      fullGrade: '已评满',
      skillDesc: '技能描述',
      deleteConfirm: '确定要删除成长记录吗？',
      pendingReview: '待审核',
      reviewNotApproved: '审核不通过',
      notApproved: '不通过',
      approved: '通过',
      batchApproved: '批量通过',
      batchNotApproved: '批量不通过',
      pictureLink: '已关联({num}人)',
      associateStudent: '关联学生',
      associatePicture: '关联图片',
      associated: '已关联',
      select: '选择',
      noSelectedStudents: '成长记录尚未选择学生',
      associateAllPictures: '请给全部图片关联学生',
      levelATitle: '一级技能',
      levelBTitle: '二级技能',
      apply: '应用',
      templateDefaultName: '评语模版',
      confirmDeleteTemplate: '确认删除该模版？',
      selectCommentTemplate: '选择评语模版',
      saveCommentAsTemplate: '保存评语为模版',
      template: '模版',
      remark: '评语',
      remarkTemplate: '评语模版',
      editTemplate: '编辑模版',
      normalDraft: '普通草稿',
      batchDraft: '批量草稿',
      enterTemplateName: '请输入模版名称',
      enterTemplateContent: '请输入评语内容',
      normalFilter: '普通筛选',
      skillFilter: '技能筛选',
      typeFilter: '类型筛选',
      confirmApprove: '确认审核通过？',
      selectPhoto: '选择照片',
      selectVideo: '选择视频',
      selectFromLocal: '从本地选择',
      selectFromAlbum: '从相册选择',
      photoLimit: '成长记录最多20张照片',
      videoLimit: '成长记录最多1个视频',
      comment: '评论',
      sendTo: '发送到',
      enterComment: '请输入评论',
      shareWithClass: '分享到班级',
      loadMoreComments: '剩余{num}条评论',
      reply: '回复',
      loadMoreReplies: '剩余{num}条回复',
      deleteCommentConfirm: '确认要删除这条评论吗？',
      deletedComment: '[该评论已被删除]',
      commentSuccess: '评论成功',
      deletedMoment: '该成长记录已被删除',
    },
    assessment: {
      class: '班级',
      classPlaceholder: '请选择班级',
      semester: '学期',
      semesterPlaceholder: '请选择学期',
      student: '学生',
      studentPlaceholder: '请选择学生',
      allStudents: '全部学生',
      gradePeriod: '评估时段',
      gradePeriodPlaceholdeer: '请选择评估时段',
      gradeTable: '评估表',
      studentFreeze: '退班',
      skill: '技能',
      assessed: '已评估',
      firstTime: '第一次',
      secondTime: '第二次',
      thirdTime: '第三次',
      forthTime: '第四次',
      more: '更多',
      finalGrade: '最终评分',
      gradeDetail: '评分详情',
      search: '搜索',
      generateReport: '生成报告',
      deleteReportTip: '确认要删除该评估报告吗？',
      reportName: '报告名称',
      createTime: '生成时间',
      operations: '操作',
      studentFirst: '请先选择学生',
      save: '保存',
      chinese: '中文',
      chinesePlaceholder: '请输入中文名称',
      english: '英文',
      englishPlaceholder: '请输入英文名称',
      assessmentResult: '评估结果',
      comment: '教师评语',
      moments: '成长记录',
      selectMoreMoments: '选择更多成长记录',
      grade: '评分',
      observationTime: '发生时间',
      uploadPhoto: '上传照片',
      selectMoments: '选择成长记录',
      saveBeforeLeave: '退出后编辑内容不会保存，确认退出编辑？',
      saveSuccess: '保存成功',
      commentLimit: '教师评语长度超过限制！',
      reportNameLimit: '请输入至少一个名称！',
      status: '状态',
      minMomentTip: '请至少选择一条成长记录！',
      schoolYear: '学年',
      rating: '评分',
      sendToParent: '发送给家长',
      openTime: '开启时间',
      sendTip: '评估进度需达到85%后才可发送给家长，发送给家长后评估表将自动开启下一张',
      sendToParentTip: '发送给家长后评分不可再编辑，确认发送给家长？',
      positive: '积极',
      negative: '消极',
      noStudentWarning: '请添加至少一名学生',
      noPointTypeWarning: '请选择积分类型',
      point: '积分',
      type: '类型',
      pointComment: '评语',
      editComment: '编辑评语',
      deleteRecordTip: '确认要删除该积分记录吗？',
      deleted: '已删除',
      allTypes: '全部类型',
      pointType: '积分类型',
      pointRecord: '积分记录',
      schoolYearPointType: '学年积分类型',
      totalPoint: '总积分',
      schoolYearTotalPoint: '学年总积分',
      pointRank: '积分排名',
      vacantPosition: '虚位以待',
      todayNewRecord: '今日新增记录',
      publishTime: '发布时间',
      creator: '创建人',
      studentPoint: '学生积分',
      addStudents: '添加学生',
      selectAll: '选择全部',
      selectStudent: '选择学生',
      batchGrading: '批量计分',
      view: '查看',
      noMomentTip: '没有更多成长记录',
      unselected: '未选中',
      selected: '选中',
      modifyReason: '修改原因',
      reasonTip: '检测到您修改了报告的技能评分，请填写原因 ',
      enterReason: '请输入修改原因！',
      modify: '修改',
      backToEdit: '返回编辑',
      gradeStatus: '报告评分',
      graded: '已评分',
      noGrade: '未评分',
      editRecord: '修改记录',
      editTime: '修改时间',
      sendReport: '发送报告',
      exportAssessmentSheet: '导出评估表',
      export: '导出',
      confirmSend: '报告发送后不可再编辑，请检查无误后点击确认',
      noGradePeriod: '当前没有评估时段',
      time: '时间',
    },
    personal: {
      personalInfo: '个人信息',
      accountSetting: '账户设置',
      avatar: '头像',
      modifyAvatar: '更换头像',
      zhName: '中文名',
      enName: '英文名',
      zhNamePlaceholder: '请输入中文名(1-50字符)',
      enNamePlaceholder: '请输入英文名(1-50字符)',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱',
      account: '帐户',
      password: '密码',
      modifyPassword: '修改密码',
      save: '保存',
      uploadAvatar: '点击上传头像',
      avatarLimit: '支持jpg、png格式的图片，大小不超过1M',
      cropTip: '鼠标滚轮缩放控制图片显示大小，拖拽调整图片位置',
      preview: '预览',
      reupload: '重新上传',
      currentPassword: '当前密码',
      currentPasswordPlaceholder: '请输入当前密码',
      newPassword: '新密码',
      newPasswordPlaceholder: '请输入新密码',
      repeatPassword: '确认密码',
      repeatPasswordPlaceholder: '请确认密码',
      wrongAvatar: '请上传正确的头像！',
      wrongBrowser: '抱歉，当前浏览器暂不支持上传头像，请更换浏览器重试',
      modifySuccess: '修改成功',
      passwordLimit: '密码必须为8-20位，字母+数字的组合',
      wrongPassword: '两次输入的密码不一致！',
      nameInvalid: '中文名或英文名有误！',
    },
    attendanceMgmt: {
      editRemark: '编辑备注',
      status: '状态',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      date: '日期',
      month: '月份',
      semester: '学期',
      allPresent: '全部准时',
      statTitle: {
        total: '应考勤人数',
        present: '准时人数',
        fullAttended: '全勤人数',
        late: '迟到人数',
        leaveEarly: '早退人数',
        personalLeave: '事假人数',
        sickLeave: '病假人数',
        absent: '缺席人数',
        abHoliday: '假期人数',
        Unrecorded: '未考勤人数',
      },
      allPresentConfirm: '确认将所有学生考勤设置为准时？',
      allClass: '全部班级',
      rate: '出勤率',
      byDate: '按日',
      byMonth: '按月',
      bySemester: '按学期',
      stat: {
        attended: '出勤（{count}人）',
        fullAttended: '全勤（{count}人）',
        present: '准时（{count}人）',
        late: '迟到（{count}人）',
        earlyLeave: '早退（{count}人）',
        sickLeave: '病假（{count}人）',
        personalLeave: '事假（{count}人）',
        absent: '缺席（{count}人）',
        absentHoliday: '假期（{count}人）',
        emptyRecord: '未考勤（{count}人）',
        noRecordNum: '{count}人未考勤',
      },
      statByDay: {
        attended: '出勤（{count}天）',
        fullAttended: '全勤（{count}天）',
        present: '准时（{count}天）',
        late: '迟到（{count}天）',
        earlyLeave: '早退（{count}天）',
        sickLeave: '病假（{count}天）',
        personalLeave: '事假（{count}天）',
        absent: '缺席（{count}天）',
        absentHoliday: '假期（{count}天）',
        emptyRecord: '未考勤（{count}天）',
        noRecordNum: '{count}天未考勤',
      },
      recordTitle: {
        particallyAttended: '的迟到记录',
        earlyLeave: '的早退记录',
        sickLeave: '的病假记录',
        personalLeave: '的事假记录',
        absent: '的缺席记录',
        absentHoliday: '的假期记录',
      },
      attendedNum: '出勤天数',
      attendanceStat: '考勤统计',
      export: '导出考勤表',
      noClass: '您还没有班级，无法进行考勤哦',
      noStudent: '您的班级还没有学生，无法进行考勤哦',
      holidayText: '您选择的日期是假期，请选择其他日期查看统计数据',
      legend: {
        remark: '备注',
        present: '代表准时',
        late: '代表迟到',
        early: '代表早退',
        sick: '代表病假',
        personal: '代表事假',
        absent: '代表缺席和假期',
      },
      editAttendance: '编辑考勤',
      attendance: '考勤',
      remarkLimitReached: '备注长度不能超过50字',
    },
    attendanceStatus: {
      FULL_ATTENDED: '全勤',
      HOLIDAY: '假期',
      ATTENDED: '准时',
      SICKNESS: '病假',
      ABSENT: '缺席',
      LATE: '迟到',
      PERSONAL: '事假',
      LEAVE_EARLY: '早退',
      ABSENT_HOLIDAY: '假期',
      EMPTY_RECORD: '未考勤',
    },
    message: {
      title: '标题',
      recipient: '收件人',
      sender: '发件人',
      sendTime: '发件时间',
      sendMessage: '发消息',
      content: '内容',
      readStatus: '已读情况',
      attachments: '附件',
      emailNotice: '邮件通知',
      uploadAttachments: '上传附件',
      attachmentTip1: '单个附件限制100M以内,',
      attachmentTip2: '最多添加10个附件',
      attachmentTip3: '最多添加5个附件',
      enterTitle: '请输入标题',
      titleLimit: '标题不能超过100字符',
      enterContent: '请输入内容',
      addTeachers: '添加教师',
      addParents: '添加家长',
      addStudents: '添加学生',
      invalidFileSize: '单个附件大小不能超过100M',
      invalidFileFormat: '仅接受后缀名为doc, docx, xls, xlsx, ppt, pptx, pdf, jpg, jpeg或png的文件',
      receivedTime: '收件时间',
      reply: '回复',
      history: '历史消息',
      recipientError: '请选择收件人',
      read: '已读',
      unread: '未读',
      selectSendMail: '请选择是否发送邮件',
      reserveEdit: '退出后将不会保留通知内容，确认退出？',
    },
    notification: {
      notificationTitle: '通知标题',
      publishTime: '发布时间',
      createNotification: '发通知',
      scope: '通知范围',
      type: '通知类型',
      readStatus: '已读情况',
      selectType: '选择通知类型',
      daily: '日常通知',
      activity: '活动通知',
      school: '校内通知',
      notificationStatus: '通知状态',
      publisher: '发布人',
      schoolReply: '校内回复',
      parentReply: '家长回复',
      reply: '回复',
      status: {
        0: '未读',
        1: '已读',
      },
      notificationContent: '通知内容',
      photos: '图片',
      uploadPhoto: '上传图片',
      attachments: '附件',
      uploadAttachment: '上传附件',
      range: '通知范围',
      students: '学生',
      teachers: '教师',
      settings: '通知设置',
      sendMail: '将通知通过邮件发送给收件人',
      allowReply: '允许家长回复',
      scopeError: '请选择通知范围',
      attachmentTip1: '支持上传文档、图片、音频',
      attachmentTip2: 'iPad暂不支持上传附件，可以使用电脑上传文件',
      saveError: '请先填写通知标题并选择通知范围',
      typeList: {
        1600: '日常通知',
        1604: '校内回复',
      },
      uploadCorrectAttachment:
        '请上传正确格式的附件(.doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .jpg, .jpeg, .png, .mp3, .wav)',
      reserveEdit: '退出后将不会保留通知内容，确认退出？',
      valueMissing: '请先完善通知内容再发送',
      replyStatus: '回复状态',
      replyStatusList: {
        0: '未回复',
        1: '已回复',
      },
      replyContent: '回复内容',
      deleteTip: '确认要删除该消息吗？',
      noTitle: '请输入通知标题',
      titleLimit: '标题限制100字以内',
      noContent: '请输入内容',
      copy: '复制再编辑',
      student: '学生',
      teacher: '教师',
      readPeople: '已读({num}人)',
      unreadPeople: '未读({num}人)',
      replyTo: '回复@',
      recipient: '收件人',
      historyNotification: '历史通知',
      replyNum: '剩余{num}条回复',
      addStudents: '添加学生',
      addTeachers: '添加教师',
      recipients: '收件人',
      time: '时间',
      noUnread: '没有未读人数，通知已全部送达~',
      noRead: '暂未有人查看此通知',
      replyTime: '回复时间',
      noReply: '暂未收到家长回复',
      sentMail: '已通过邮件发送',
      unsentMail: '未通过邮件发送',
      allowedReply: '已允许家长回复',
      disallowedReply: '未允许家长回复',
      uploadComplete: '上传完成',
      setting: '通知设置',
      sender: '发件人',
    },
    setting: {
      name: '名称',
      gradeName: '年级名称',
      schoolYear: '学年',
      semester: '学期',
      semesterTime: '学期时间',
      status: '状态',
      assessmentFrame: '评估框架',
      enabledSchoolYear: '启用学年',
      assessmentSheet: '评估表名称',
      assessmentProgress: '评估进度',
      creator: '创建人',
      schoolType: '学校性质',
      schoolTypeTip: '*学校性质暂不支持修改，若要修改，请联系工作邮箱help@enseed.cn',
      semesterTip: '*学期暂不支持修改，若要修改，请联系工作邮箱help@enseed.cn',
      assessmentFrameTip:
        '*评估框架启用时，在学年未结束前不可修改，新学年学期开始前15天内支持修改，修改后评估表也会改变',
      enseedFrameIntro:
        '该评估框架应用于幼儿园和小学的学生进行技能评估使用。</br>在该评估框架下，评估技能分为3个层级，在一学年内，每个月将有一张三级技能不同的评估表，教师针对每个三级 技能每月评估一次，分值分为3个等级，将以EMERGING、PERFORMING、MASTERING展示。</br>每月评估完成后家长将收到一张月度的评估表。期末家长将收到一份整学期评估报告。',
      eyfsFrameIntro:
        '该评估框架应用于幼儿园和小学的学生进行技能评估使用。</br>在该评估框架下，评估技能分为2个层级，每学年将使用同一张评估表，针对每个二级技能评估不限次数。分值分为 9个等级，将以Emerging1、Emerging2、Emerging3、Developing4、Developing5、Developing6、Secure7、Secure8、Secure9展示。</br>期中和期末家长将收到2份评估报告。',
      frameDetailTip: '评估框架启用后，管理员可到评估表设置菜单下，添加该评估框架的评估表。',
      assessmentSheetStructure: '评估表结构',
      levelA: '一级',
      levelB: '二级',
      levelC: '三级',
      levelASkill: '一级技能',
      levelBSkill: '二级技能',
      levelCSkill: '三级技能',
      lastLevelTip: '可自定义的技能',
      leaveTip: '返回将不会保存编辑内容，确认返回？',
      addLevelBSkill: '添加二级技能',
      addLevelCSkill: '添加三级技能',
      doubleSheetName: '该框架和年级下已存在同名评估表，请修改评估表名称',
      deleteLevelBTip: '确认删除二级技能？',
      deleteLevelCTip: '确认删除三级技能？',
      order: '使用顺序',
      introduction: '说明',
      abbreviation: '缩写',
      noAbbreviation: '请输入缩写',
      abbreviationLimit: '缩写字数不能超过10个字符',
      noLevelCSkill: '请输入三级技能',
      noLevelBSkill: '请输入二级技能',
      rubrics: '说明',
      all: '全部',
      enable: '启用',
      disable: '停用',
      enabled: '启用中',
      disabled: '未启用',
      deleteAssessmentSheet: '确认删除评估表？',
      enableEnSEEDAssessmentSheet: '确认启用评估表？',
      enableEYFSAssessmentSheet: '启用后，原来的评估表将被替换，确认启用？',
      disableAssessmentSheet: '停用后，班级评估将不使用该评估表，确认设为停用？',
      sentToParent: '已发送家长',
      unsentToParent: '未发送家长',
      enterName: '请输入名称',
      adjustOrder: '调整使用顺序',
      createSheet: '新建评估表',
      up: '向上',
      down: '向下',
      sendStatus: '发送状态',
      appliedSection: '应用年级',
      sheetOrder: '评估表顺序',
      createTime: '创建时间',
      enterSheetName: '请输入评估表名称',
      orderTip1: '只可以调整未评估的评估表顺序',
      orderTip2: '教师将根据评估表使用顺序进行评估',
      saveTip: '评估表需要有至少一个三级技能',
      typeSetting: '类型设置',
      typeTip: '说明：该字段用于成长记录的类型选择',
      addType: '添加类型',
      deleteTypeTip: '确认删除该类型？',
      abbrRepeat: '技能缩写重复，请更换缩写',
      sendToParent: '是否发送给家长',
      canSend: '可以发送',
      cannotSend: '不可发送',
      sendPercent: '允许发送百分比',
      textLimit: '文本字数超出限制',
    },
    assessmentStatus: {
      1302: '评估中',
      1303: '未评估',
      1304: '已评估',
    },
    assessmentReportStatus: {
      1501: '未发送',
      1502: '已发送',
    },
    calendar: {
      schoolYear: '{year}学年',
      holidayPlaceholder: '输入假期名称',
      deleteConfirm: '确定要删除这条日程吗？',
      workingDay: '工作日',
      holiday: '假期',
      summerHoliday: '暑假',
      winterHoliday: '寒假',
      semesterStartDate: '学期开始日',
      semesterEndDate: '学期结束日',
      setDate: '设置工作日/假期',
      addSchedule: '设置日程',
      openParentView: '查看家长视图',
      closeParentView: '退出家长视图',
      date: '日期',
      name: '名称',
      time: '时间',
      allDay: '全天',
      location: '地点',
      remark: '备注',
      status: '状态',
      visibleToParent: '家长可见',
      invisibleToParent: '家长不可见',
      viewSchedule: '查看日程',
    },
    curriculum: {
      class: '班级',
      allClass: '全部班级',
      semester: '学期',
      allSemester: '全部学期',
      createCurriculum: '新增课表',
      name: '课表名称',
      date: '日期',
      creator: '创建人',
      createTime: '创建时间',
      confirmDelete: '确认要删除该课表吗？',
      uploadCurriculum: '上传课表',
      namePlaceholder: '请输入名称',
      semesterPlaceholder: '请选择学期',
      classPlaceholder: '请选择班级',
      pdfNotSupport: '当前浏览器不支持预览PDF文件，请下载浏览:',
      downloadPDF: '下载PDF',
    },
    pictureBook: {
      pictureBook: '绘本',
      suitableSection: '适用年级',
      bookNum: '绘本数量',
      subscribeNum: '订阅人数',
      operateRecord: '操作记录',
      date: '日期',
      name: '名称',
      namePlaceholder: '请输入学生名称',
      student: '学生',
      class: '班级',
      section: '年级',
      operator: '操作人',
      operateTime: '操作时间',
      openDate: '开启日期',
      subscribeDetail: '订阅详情',
      subscribed: '已订阅',
      notSubscribed: '未订阅',
      batchStopSubscribe: '批量停止订阅',
      batchBeginSubscribe: '批量开启订阅',
      studentNum: '{num}人',
      expand: '展开',
      collapse: '收起',
      stopSubscribe: '停止订阅',
      beginSubscribe: '开启订阅',
      stopSuccess: '停止订阅成功',
      beginSuccess: '开始订阅成功',
      confirmStopSubscribe: '确认停止订阅？',
      confirmBeginSubscribe: '确认开启订阅？',
      open: '{time}开启',
    },
    mibp: {
      firstPage: '已经是第一页',
      lastPage: '已经是最后一页',
      loading: '加载中... {progress}',
    },
    phdCourse: {
      firstPage: '已经是第一页',
      lastPage: '已经是最后一页',
      loading: '加载中... {progress}',
      cover: '封面',
      catalog: '目录',
    },
    weekday: {
      0: '周日',
      1: '周一',
      2: '周二',
      3: '周三',
      4: '周四',
      5: '周五',
      6: '周六',
    },
    noContent: {
      attendance: '无考勤~',
      moment: '无成长记录~',
      template: '尚未保存评语模版',
      draft: '无草稿~',
      parentReply: '暂无家长回复~',
      pendingReview: '没有待审核的成长记录~',
      reviewNotAudited: '还没有审核不通过的成长记录呢~',
      systemMessage: '暂未收到消息~',
      class: '暂无班级',
      schoolYear: '暂无学年',
      semester: '暂无学期',
      student: '暂无学生',
      gradePeriod: '暂无评估时段',
      section: '暂无年级',
      gradeTable: '暂无评估表',
      book: '暂无绘本',
      file: '暂无文件',
      deletedMoment: '成长记录已被删除',
      photo: '暂无照片~',
      video: '暂无视频~',
    },
    album: {
      class: '班级',
      uploadPhoto: '上传照片',
      uploadVideo: '上传视频',
      bulkManage: '批量管理',
      photo: '照片',
      video: '视频',
      download: '下载',
      delete: '删除',
      completeManage: '完成管理',
      selectedNum: '已选择: {num}',
      totalNum: '一共: {num}',
      clear: '清空',
      selectAll: '全选',
      selectMonthAll: '本月全选',
      upload: '上传',
      complete: '完成',
      continueUpload: '继续上传',
      uploadPhotoSuccess: '{num}张照片上传成功',
      uploadPhotoFailed: '{num}张照片上传失败',
      uploadVideoSuccess: '{num}个视频上传成功',
      uploadVideoFailed: '{num}张照片上传失败',
      uploadFailed: '上传失败',
      createTime: '创建时间',
      creator: '创建人',
      source: '来源',
      sourceType: {
        1451: '相册上传',
        1452: '成长记录',
      },
      deletePhotoConfirm: '确认删除照片？',
      deleteVideoConfirm: '确认删除视频？',
      selectedPhotoStat: '已选择{selected}张照片',
      totalPhoto: '，共计：{total}张照片',
      selectedVideoStat: '已选择{selected}个视频',
      totalVideo: '，共计：{total}个视频',
      waitingUpload: '等待上传',
      preview: '预览',
    },
    dailyCare: {
      class: '班级',
      date: '日期',
      name: '姓名',
      snack: '零食',
      am: '上午',
      pm: '下午',
      lunch: '午饭',
      nap: '午睡',
      toilet: '厕所',
      urinate: '小便',
      defecate: '大便',
      remark: '备注',
      lifeLevel: {
        green: '绿色：状况良好',
        yellow: '黄色：需要注意',
        red: '红色：需要采取措施调整',
      },
      times: '{count}次',
      student: '学生',
      performance: '表现',
      record: '记录',
      time: '时间',
      dailyCareTip: '生活表现等级说明',
      remarkLimitReached: '备注长度不能超过200字',
      noDailyCare: '暂无生活记录~',
    },
    diary: {
      name: '姓名',
      points: '分数',
      count: '数量',
      positive: '积极',
      negative: '消极',
      nurseVisit: '护士来访',
      diaryType: '日记簿类型',
      subtype: '子类型',
      time: '时间',
      location: '地点',
      relatedStudents: '关联学生',
      description: '描述',
      injuredParts: '受伤部位',
      attachments: '附件',
      shareWithParents: '分享家长',
      uploadAttachments: '上传附件',
      addStudents: '添加学生',
      attachmentTip: '单个附件限制100M以内',
      submitSuccess: '提交成功',
      selectDiaryType: '请选择日记簿类型',
      selectSubtype: '请选择子类型',
      inputDescription: '请输入描述',
      class: '班级',
      totalPoints: '总分',
      createTime: '创建时间',
      creator: '创建人',
      diaryDetail: '日记簿详情',
      deleteDiaryTip: '确定要删除这条日记簿吗？',
      reserveEdit: '退出后将不会保留日记簿内容，确认退出？',
    },
    takeLeave: {
      class: '班级',
      student: '学生',
      leavePeople: '请假人',
      leaveType: '请假类型',
      leaveDuration: '请假时长',
      leaveReason: '请假事由',
      status: '状态',
      leaveTime: '请假时间',
      illness: '病假',
      personal: '事假',
      /* eslint-disable-next-line */
      absent_holiday: '假期',
      pending: '待审核',
      approved: '已通过',
      declined: '已拒绝',
      retrieved: '已撤销',
      am: '上午',
      pm: '下午',
      day: '{duration}天',
      approve: '通过',
      reject: '拒绝',
      approveConfirm: '请假通过后会自动同步考勤状态，确认通过请假审批？',
      rejectConfirm: '确认拒绝请假审批？',
      leaveAudit: '请假审批',
      leaveStatus: '请假状态',
    },
    operation: {
      9001: '停止订阅',
      9002: '开启订阅',
    },
    systemMessage: {
      time: '时间',
      type: {
        1651: '评分修改',
        1613: '点赞',
        1614: '评论',
        1622: '审批',
      },
      typeDescription: {
        1651: '修改了报告评分',
        1613: '给成长记录点赞',
        1614: '评论了成长记录',
        1622: '请假审批提醒',
      },
    },
    transfer: {
      listTitle: '{title}列表',
      selectedNum: '已选择{title}{num}人',
      deleteAll: '全部删除',
      selectAll: '全选',
      enterName: '请输入{title}姓名',
      ungrouped: '未分组',
      undivided: '未分班',
    },
    notFound: {
      notFound: '抱歉，您访问的页面不存在。',
      backToHome: '返回首页',
    },
  },
}

export const dateTimeFormats: DateTimeFormats = {
  en: {
    month: {
      year: 'numeric',
      month: 'short',
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  zh: {
    month: {
      year: 'numeric',
      month: 'short',
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
  },
}
